module.exports = __webpack_public_path__ + "img/2-full-sm.91a595c8.jpg";